import {
    MutableRefObject,
    useEffect
} from 'react';

import {Cache} from '@aws-amplify/cache';
import {useNavigate} from 'react-router-dom';

import {ActivityEventsService} from '../../debug-mode/activity-events/services/ActivityEventsService';
import {AUTH_TIMEOUT_MS} from '../config';

/**
 * Starts a timeout when the user is in the authorizing state.
 * If no auth event completes within AUTH_TIMEOUT_MS, resets the
 * pac-authorizing flag and navigates to /auth-timeout.
 *
 * The authCompletedRef guard prevents the timeout from firing
 * if an auth event was already handled by useAuthEventListener.
 */
export const useAuthTimeout = (
    isAuthorizing: boolean,
    authCompletedRef: MutableRefObject<boolean>
) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthorizing) {
            return;
        }

        const timeoutId = setTimeout(() => {
            if (authCompletedRef.current) {
                return;
            }

            console.trace('LOGIN APP. INDEX PAGE. AUTH TIMEOUT - No auth event received within timeout');

            ActivityEventsService.add(
                'Authorization Timeout',
                `No authentication response received within ${AUTH_TIMEOUT_MS / 1000} seconds`,
                undefined
            );

            Cache.setItem('pac-authorizing', 'no');
            navigate('/auth-timeout');
        }, AUTH_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, [isAuthorizing, authCompletedRef, navigate]);
};
